import React from "react";
import * as styles from "./SubscribeFormInfoCard.module.scss";
import {
  ResponsiveSanityImage,
  ImageRatio,
  ResponsiveSanityImageProps
} from "@silversea-ssc/ui-components-react";

export interface SubscribeFormInfoCardProps {
  image?: ResponsiveSanityImageProps["image"];
  title: string | JSX.Element;
  content?: JSX.Element;
}

const SubscribeFormInfoCard: React.FC<SubscribeFormInfoCardProps> = ({
  image,
  title,
  content
}) => {
  return (
    <div className={styles.card}>
      {image && (
        <ImageRatio ratio="card">
          <ResponsiveSanityImage
            className={styles.image}
            image={image}
            defaultWidth={350}
            defaultHeight={200}
          />
        </ImageRatio>
      )}
      <div className={styles.title}>{title}</div>
      {content && <div>{content}</div>}
    </div>
  );
};

export default SubscribeFormInfoCard;
